var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"scrollable-container",attrs:{"grid-list-lg":"","d-flex":"","fluid":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }